import createAction from 'modules/workLook/actions/_createAction';

const SET_MAP_TYPE = createAction('SET_MAP_TYPE');

export default SET_MAP_TYPE;
